import './SupportEmail.css';

export const SUPPORT_EMAIL = 'artlypics@proton.me';

export default function SupportEmail({ className = '' }) {
    return (
        <div className={`supportEmail ${className}`.trim()}>
            Support: <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
        </div>
    );
}
